import { translate } from '@jsverse/transloco';
import OlMap from 'ol/Map';
import {Observable, Subscription} from 'rxjs';

declare let ol: any;

export class OpenlayersTooltip {
  private map: OlMap;
  private clickStartDrawingMsg: string;
  private continuePolygonMsg: string = translate('maps.draw_polygon');
  private continueLineMsg: string = translate('maps.line_polygon');
  private addStakeholderMsg: string = translate('maps.import_stakeholder');

  private helpTooltip: any;
  private measureTooltip: any;

  private helpTooltipElement: HTMLElement;
  private measureTooltipElement: HTMLElement;

  private selectedTool$: Observable<string>;
  private purposeTool$: Observable<string>;
  private selectedToolSubscription: Subscription;
  private purposeToolSubscription: Subscription;

  constructor(map: OlMap, clickStartDrawingMsg: string, selectedTool$: Observable<string>, purposeTool$: Observable<string>) {
    this.map = map;
    this.clickStartDrawingMsg = translate(`maps.${clickStartDrawingMsg}`);
    this.selectedTool$ = selectedTool$;
    this.purposeTool$ = purposeTool$;
    this.init();
  }

  public on(): void {
    this.createHelpTooltip();
  }

  public off(): void {
    this.removeHelpTooltip();
  }

  public write(text: string): void {
    this.clickStartDrawingMsg = text;
  }

  /**
   * @deprecated
   * @returns {HTMLElement}
   */
  public setStatic(): HTMLElement {
    if (this.measureTooltipElement && this.measureTooltip) {
      this.measureTooltipElement.className = 'tooltip tooltip-static';
      this.measureTooltip.setOffset([0, -7]);

      // unset tooltip so that a new one can be created
      this.measureTooltipElement = null;
    }

    return this.measureTooltipElement;
  }

  /**
   * @deprecated
   * @param coordinate
   */
  public position(coordinate): void {
    if (this.measureTooltip) {
      this.measureTooltip.setPosition(coordinate);
    }
  }

  private init() {
    this.selectedToolSubscription = this.selectedTool$.subscribe((selectedTool: string) => {
      if (selectedTool === 'area') {
        this.clickStartDrawingMsg = this.continuePolygonMsg;
      } else if (selectedTool === 'length') {
        this.clickStartDrawingMsg = this.continueLineMsg;
      }
    });

    this.purposeToolSubscription = this.purposeTool$.subscribe((purposeTool: string) => {
      if (purposeTool === 'add-stakeholder') {
        this.clickStartDrawingMsg = this.addStakeholderMsg;
      }
    });

    this.map.on('pointermove', evt => {
      if (evt.dragging || !this.helpTooltipElement) {
        return;
      }

      this.helpTooltipElement.innerHTML = this.clickStartDrawingMsg;
      this.helpTooltip.setPosition(evt.coordinate);

      this.helpTooltipElement.classList.remove('hidden');
    });

    this.map.getViewport().addEventListener('mouseout', () => {
      if (this.helpTooltipElement) {
        this.helpTooltipElement.classList.add('hidden');
      }
    });
  }

  /**
   * Creates a new help tooltip
   */

  private removeHelpTooltip() {
    if (this.helpTooltipElement && this.helpTooltipElement.parentNode) {
      this.map.removeOverlay(this.helpTooltip);
      this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      this.helpTooltipElement = null;
    }
  }

  private createHelpTooltip() {
    this.removeHelpTooltip();
    this.helpTooltipElement = document.createElement('div');
    this.helpTooltipElement.className = 'tooltip hidden';
    this.helpTooltip = new ol.Overlay({
      element: this.helpTooltipElement,
      offset: [15, 0],
      positioning: 'center-left'
    });
    this.map.addOverlay(this.helpTooltip);
  }

  /**
   * @deprecated
   * Creates a new measure tooltip
   */
  private removeMeasureTooltip() {
    if (this.measureTooltipElement && this.measureTooltipElement.parentNode) {
      this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
    }
  }

  /**
   * @deprecated
   */
  private createMeasureTooltip() {
    this.removeMeasureTooltip();
    this.measureTooltipElement = document.createElement('div');
    this.measureTooltipElement.className = 'tooltip tooltip-measure';
    this.measureTooltip = new ol.Overlay({
      element: this.measureTooltipElement,
      offset: [0, -15],
      positioning: 'bottom-center'
    });

    this.map.addOverlay(this.measureTooltip);
  }

  public destroy() {
    this.selectedToolSubscription.unsubscribe();
    this.purposeToolSubscription.unsubscribe();
  }
}
